export default __webpack_public_path__ + "static/media/r5.925aea3a.jpeg";